import React from 'react';
import './InputUI.css';
import { SymbolToRule } from 'entities/core/LSystem';

export type InputFields = {
    step: number;
    depth: number;
    angle: number;
    forward: string;
    axiom: string;
    rules: SymbolToRule;
    name: string;
};

const defaultValues = {
    step: 0,
    depth: 0,
    angle: 0,
    axiom: '',
    rules: {},
};

type SetSystem = (InputFields: InputFields) => void;
export type Props = {
    inputFields: InputFields;
    setSystem: SetSystem;
};

const parseRules = (input: string): SymbolToRule => {
    const rules: SymbolToRule = {};
    input
        .split('\n')
        .filter((line) => line.trim().length > 0)
        .forEach((line) => {
            const symbolAndRule = line.split('=');
            console.log(symbolAndRule);
            rules[symbolAndRule[0].trim()] = symbolAndRule[1].trim();
        });

    return rules;
};

const renderRules = (rules: SymbolToRule): string => {
    let value = '';
    Object.keys(rules).forEach((key) => {
        value = value + key + '=' + rules[key] + '\n';
    });

    return value;
};

const InputUI = ({ inputFields, setSystem }: Props) => {
    const updateValue: InputFields = {
        ...defaultValues,
        ...inputFields,
        name: 'custom',
    };

    return (
        <div className="container">
            <label>
                Step:{' '}
                <input
                    id="step"
                    type="text"
                    defaultValue={inputFields?.step}
                    onBlur={(event): void =>
                        setSystem({
                            ...updateValue,
                            step: parseInt(event.target.value),
                        })
                    }
                />
            </label>
            <label>
                Depth:{' '}
                <input
                    id="depth"
                    type="text"
                    defaultValue={inputFields?.depth}
                    onBlur={(event): void =>
                        setSystem({
                            ...updateValue,
                            depth: parseInt(event.target.value),
                        })
                    }
                />
            </label>
            <label>
                Angle:{' '}
                <input
                    id="angle"
                    type="text"
                    defaultValue={inputFields?.angle}
                    onBlur={(event): void =>
                        setSystem({
                            ...updateValue,
                            angle: parseInt(event.target.value),
                        })
                    }
                />
            </label>
            <label>
                Forward:{' '}
                <input
                    id="depth"
                    type="text"
                    defaultValue={inputFields?.forward}
                    onBlur={(event): void =>
                        setSystem({
                            ...updateValue,
                            forward: event.target.value,
                        })
                    }
                />
            </label>
            <label>
                Axiom:{' '}
                <input
                    id="axiom"
                    type="text"
                    defaultValue={inputFields?.axiom}
                    onBlur={(event): void =>
                        setSystem({
                            ...updateValue,
                            axiom: event.target.value,
                        })
                    }
                />
            </label>
            <label>
                Rules:{' '}
                <textarea
                    id="rules"
                    defaultValue={renderRules(inputFields?.rules)}
                    onBlur={(event): void =>
                        setSystem({
                            ...updateValue,
                            rules: parseRules(event.target.value),
                        })
                    }
                />
            </label>
        </div>
    );
};

InputUI.defaultProps = {
    inputFields: defaultValues,
};

export default InputUI;
